export default __webpack_public_path__ + "static/media/valid.6c930dd9.svg";